// import { useState, useTransition } from "react";
import { DentistCard } from "./dentistComponents/DentistCards/DentistCard.jsx";
import AddForm from "./dentistComponents/AddForm/addForm";
import app from "./dentistStyles/app.module.css";
import DentistHeader from "./dentistComponents/DentistHeader/DentistHeader.jsx";
import { useData } from "./dentistContext/DentistConferenceContext";
import CopyRightFooter from "../CopyRightFooter/CopyRightFooter.jsx";
import Spinner from "../auxiliary/LoadingSpinner/LoadingSpinner"
import NetworkConnection from "../auxiliary/NetworkConnection/NetworkConnection.jsx";
// import { QueryClientProvider, queryClient } from "react-query";

const DentistConference = () => {
  const { state, filteredData, updateItem, addItem, deleteItem, mama } = useData();
  const {isLoading,isError} = state

  return (
    <div className="appContainer">
      <header className="appHeader">
        <DentistHeader />
      </header>
      <main className="appBody">
        <NetworkConnection>
        <div className={app.appcontents}>

          <div className={app.cardscontainer}>
            {isError ? (
              <>
                <Spinner msg="المخدم متوقف"/>
              </>
            ) : (
              isLoading?(
                <>
                <Spinner msg="جاري ارسال المعلومات"/>
              </>
              ):(filteredData && filteredData.length > 0)&&
              filteredData.sort((a, b) => {
                return b.id - a.id;
              }).map((element) => {
                return (
                  <DentistCard
                    key={element.id + new Date()}
                    element={element}
                  ></DentistCard>
                );
              })
            )}
          </div>
          <div className={app.formcontainer}>
            <AddForm/>
          </div>
        </div>
        </NetworkConnection>
      </main>
      <footer className="appFooter">
        <CopyRightFooter />
      </footer>
    </div>
  );
};
export default DentistConference;
